/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */

import React from 'react';

import { DslOperator } from './interface';

interface IElasticDslEntitlementContext {
  query: string | undefined;
  setQuery: (query: string) => void;
  addOperator: (operator: DslOperator) => void;
  clearValue: () => void;
  onCancel: () => void;
  onAdd: () => void;
}

const defaultDslContextState: IElasticDslEntitlementContext = {
  query: undefined,
  setQuery: (_query) => {},
  addOperator: (_operator) => {},
  clearValue: () => {},
  onCancel: () => {},
  onAdd: () => {},
};

export const ElasticDslEntitlementContext = React.createContext<IElasticDslEntitlementContext>(defaultDslContextState);
